export default __webpack_public_path__ + "fa7a3ea0e295ee6802a1b9e25bc32a72.png";